import React, { useState } from "react";

import appStore from "app/AppStore";

export default function useChatModel(props) {
  const { useMatchingTokenModel, modelVariants, baseChatModel } = props;

  const [model, setModel] = useState(null);

  const handleLoad = () => {
    const modelsByTokens = {};

    for (let i = 0; i < modelVariants.length; i++) {
      const variant = modelVariants[i];

      if (variant.isSnapshot || variant.legacy) continue;

      if (!modelsByTokens[variant.model]) {
        modelsByTokens[variant.model] = {};
      }

      if (!modelsByTokens[variant.model][variant.maxTokens]) {
        modelsByTokens[variant.model][variant.maxTokens] = [];
      }

      modelsByTokens[variant.model][variant.maxTokens].push(i);
    }

    appStore.chatSettingsStore.setModelsByTokens(modelsByTokens);
    return modelsByTokens;
  };

  const getModelHelper = ({ tokensSize }) => {
    if (!useMatchingTokenModel) return baseChatModel;

    if (!appStore.chatSettingsStore.modelsByTokens) handleLoad();

    const tokensSizes = Object.keys(
      appStore.chatSettingsStore.modelsByTokens[baseChatModel.model]
    );

    let i;
    for (i = 0; i < tokensSizes.length; i++) {
      const size = tokensSizes[i];

      const percentTokens = Math.floor(size * 0.9);
      // console.log(`percentTokens->`, tokensSize, `${percentTokens}-${size}`);

      if (tokensSize >= percentTokens) {
        continue;
      }

      break;
    }

    if (i > tokensSizes.length - 1) return;

    const index = appStore.chatSettingsStore.modelsByTokens[baseChatModel.model][tokensSizes[i]][0];

    return modelVariants[index];
  };

  const getModel = ({ tokensSize }) => {
    const model = getModelHelper({ tokensSize });

    setModel(model);
    return model;
  };

  return { model, getModel };
}
